import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "hub-tab-container",
  class: "w-full h-full bg-gray-lp-1400 p-2 pb-4"
}
const _hoisted_2 = { class: "w-full h-full flex flex-col flex-grow overflow-y-auto" }
const _hoisted_3 = {
  key: 1,
  class: "p-3 bg-white flex flex-col gap-y-2 rounded-2xl mt-2 mb-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_Actions = _resolveComponent("Actions")!
  const _component_CardProgress = _resolveComponent("CardProgress")!
  const _component_CardCollipsableIncoming = _resolveComponent("CardCollipsableIncoming")!
  const _component_ConfirmAction = _resolveComponent("ConfirmAction")!
  const _component_CopyTemplate = _resolveComponent("CopyTemplate")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Header, { "data-summary": _ctx.dataSummary }, null, 8, ["data-summary"]),
        (_ctx.isEmptyList)
          ? (_openBlock(), _createBlock(_component_EmptyState, {
              key: 0,
              class: "bg-white mt-2 h-full rounded-xl",
              icon: "noData_empty",
              customHeaderMessage: _ctx.$t('dashboard.hanging.emptyHeader'),
              customMessage: _ctx.$t('dashboard.hanging.emptyMessage')
            }, null, 8, ["customHeaderMessage", "customMessage"]))
          : (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode(_component_Filter, {
                class: "mb-2",
                onFilter: _ctx.getFilter,
                isHangingIncoming: ""
              }, null, 8, ["onFilter"]),
              _createVNode(_component_Actions, {
                class: "mb-2",
                data: _ctx.hangingIncomingList,
                onUpdate: _ctx.updateStatus,
                onDownload: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadHangingIncoming([])))
              }, null, 8, ["data", "onUpdate"]),
              _createVNode(_component_CardProgress, {
                "total-completed": _ctx.dataSummary.activitiesDone,
                "total-activities": _ctx.dataSummary.totalActivities,
                "total-pending": _ctx.dataSummary.activitiesPending,
                "is-loading": _ctx.isLoadingFetch
              }, null, 8, ["total-completed", "total-activities", "total-pending", "is-loading"]),
              (_ctx.hangingIncomingList.length || _ctx.isLoadingList)
                ? (_openBlock(), _createBlock(_component_CardCollipsableIncoming, {
                    key: 0,
                    modelValue: _ctx.hangingIncomingList,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.hangingIncomingList = $event)),
                    loading: _ctx.isLoadingList,
                    onTemplate: _ctx.onClickTemplateMessage,
                    onSuccess: _ctx.onSuccessUpdateStatus,
                    onDownload: _ctx.downloadHangingIncoming
                  }, null, 8, ["modelValue", "loading", "onTemplate", "onSuccess", "onDownload"]))
                : (_openBlock(), _createBlock(_component_EmptyState, {
                    key: 1,
                    class: "mt-2 h-full",
                    icon: "ill_spot_search",
                    customHeaderMessage: _ctx.$t('dashboard.hanging.searchEmptyHeader'),
                    customMessage: _ctx.$t('dashboard.hanging.searchEmptyMessage')
                  }, null, 8, ["customHeaderMessage", "customMessage"]))
            ]))
      ])
    ]),
    _createVNode(_component_ConfirmAction, {
      modelValue: _ctx.isOpenModal,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isOpenModal = $event)),
      title: _ctx.$t('dashboard.hanging.confirmTitle'),
      textSuccess: _ctx.$t('dashboard.hanging.confirmSuccess'),
      messageHtml: _ctx.messageHtml,
      onConfirm: _ctx.onUpdateStatus
    }, null, 8, ["modelValue", "title", "textSuccess", "messageHtml", "onConfirm"]),
    _createVNode(_component_CopyTemplate, {
      modelValue: _ctx.isOpenTemplate,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isOpenTemplate = $event)),
      awb: _ctx.awb,
      group: _ctx.group
    }, null, 8, ["modelValue", "awb", "group"])
  ], 64))
}